import React, { Component, useState, useEffect, useContext } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import SglContext from '../SglContext';
import "./addDropClass.css";


import delete_image from "../images/trash.png";

//API END POINTS
// const sgl_webservice_iphone_entry = process.env.REACT_APP_SGL_API+'/iphonev2/addentryv2/';
// const sgl_webservice_iphone_class = process.env.REACT_APP_SGL_API+'/iphonev2/classadddropv2/';
// const user_info_url = process.env.REACT_APP_NEST_API+'/users/getLoggedInUser';


class AddDropClass extends React.Component {
      
    state = {
      current_show: localStorage.getItem('show_id'),

      governing_organization: '',
      company_name: '',
      logged_in_people_id: '',
      credit_hold:false,

      entry_on_credit_hold: false,
      entry_on_vet_hold: false,
      show_data:{},
      entries_list: [],
      riders_list: [],
      classes_list: [],
      divisions_list: [],
      divisions_filtered_list: [],
      change_rider_classes :[],

      rider_select_disabled:true,
      txt_div_disabled:true,
      div_select_disabled:true,
      txt_class_disabled:true,
      class_select_disabled:true,

      selected_entry: {},
      selected_entry_id:'-4',
      selected_rider_id:'-4',
      division_to_add:'-1',
      selected_division: {},
      division_search: '',
      class_to_add:'-1',
      class_numbers_to_add: [],
      // classes_to_add: [],
      class_numbers_to_drop: [],
      classes_to_drop: [],
      selected_classes:[],
      entry_classes: [],
      class_selection_error_msg: '',
      entry_numbers:'',
      userData: {},

      change_div_rider: false,

      pending_requests_list: [],

      class_add_fee:'',
      class_add_fee_each:'',
      class_add_date:'',
      class_add_fee_time:'',
      class_add_fee_amount: '',
      charge_add_fee_on_web: false,
      class_drop_fee:'',
      class_drop_fee_each:'',
      class_drop_fee_date:'',
      class_drop_fee_time:'',
      class_drop_fee_amount: '',
      charge_drop_fee_on_web: false,

      switch_allowed: 0,
      switch_company_name: '',
      loading: true,
      restrict_junior_riders: false,
      parent_verified: null

    }

    constructor() {
      super();
      // bind function in constructor instead of render
    }
    componentDidUpdate(prevProps){
        if(prevProps.current_show !== this.props.current_show){
            var show_id = this.props.current_show;
            this.getSelectedShowEntries(show_id);
            this.getSelectedShowData(show_id);
            this.setInitialState();
            this.setState({
                current_show: show_id,
            });
            
        }
    }
    
    // Define API endpoints as getter methods so they can access context
    get sgl_webservice_iphone_entry() {
      return this.context.sglApiUrl + '/iphonev2/addentryv2/';
    }

    get sgl_webservice_iphone_class() {
      return this.context.sglApiUrl + '/iphonev2/classadddropv2/';
    }

    get user_info_url() {
      return this.context.nestApiUrl + '/users/getLoggedInUser';
    }

    setInitialState(){
      this.setState({
        riders_list: [],

        rider_select_disabled:true,
        txt_div_disabled:true,
        div_select_disabled:true,
        txt_class_disabled:true,
        class_select_disabled:true,
        
        selected_entry: {},
        selected_entry_id:'-4',
        selected_rider_id:'-4',
        division_to_add:'-1',
        selected_division: {},
        division_search: '',
        class_to_add:'-1',
        class_numbers_to_add: [],
        // classes_to_add: [],
        class_numbers_to_drop: [],
        classes_to_drop: [],
        selected_classes:[],
        entry_classes: [],
        class_selection_error_msg: '',
        entry_numbers: ''

      });
      document.getElementById('select_div_msg').style.display = "none";
      document.getElementById('select_class_msg').style.display = "none";
      document.getElementById('enter_class_msg').style.display = "none";
      document.getElementById('step_1_warning').style.display = "none";
      document.getElementById('add_drop_fields').style.display = "block";
      document.getElementById('save_button_div').style.display = "block";
      document.getElementById('add_drop_success_message').style.display = "none";

    }

    resetChangeEntryState(){
      this.setState({
        riders_list: [],

        txt_div_disabled:true,
        div_select_disabled:true,
        txt_class_disabled:true,
        class_select_disabled:true,
        
        selected_rider_id:'-4',
        division_to_add:'-1',
        selected_division: {},
        division_search: '',
        class_to_add:'-1',
        class_numbers_to_add: [],
        // classes_to_add:[],
        class_numbers_to_drop: [],
        classes_to_drop: [],
        class_selection_error_msg: '',
        entry_numbers: ''

      });
      document.getElementById('select_div_msg').style.display = "none";
      document.getElementById('select_class_msg').style.display = "none";
      document.getElementById('enter_class_msg').style.display = "none";
      document.getElementById('step_1_warning').style.display = "none";

    }
    getQueryVariable(variable)
    {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] === variable){return pair[1];}
         }
         return(false);
    }
    componentDidMount() {
      var switches = this.context.switches.switches;
      // switch_name: "Class Adds/Drops"
      var switch_found = switches.find(el => el.switch_name === "Class Adds/Drops");
      var switch_allowed = 0;
      if(switch_found){
        switch_allowed = switch_found.value;
      }
      this.setState({
        switch_allowed: switch_allowed
      });
      if(switch_allowed){
        this.getAllData(localStorage.getItem('show_id'));
        document.title = "Class adds/drops";
        window.addEventListener('beforeunload', this.handleLeavePage);
      } else {
        this.setState({
          switch_allowed: switch_allowed,
          switch_company_name: this.context.switches.company_name?this.context.switches.company_name:'The Company',
          loading:false
        })
      }
    }
    componentWillUnmount() {
      window.removeEventListener('beforeunload', this.handleLeavePage);
    }
  
    handleLeavePage(e) {
      const confirmationMessage = 'Are you sure you want to leave?';
      e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
      return confirmationMessage;              // Gecko, WebKit, Chrome <34
    }
    
    getAllData(show_id){
        this.getUserData();
        this.getSelectedShowEntries(show_id);
        this.getSelectedShowData(show_id);
    }

    getSelectedShowEntries(show_id){
        this.setState({loading:false});
        axios.get(this.sgl_webservice_iphone_class+'GetShowEntries',{
            params : {
                show_id : show_id,
                company_id: this.context.company_id,
                team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
            }
        }).then(results => {
            this.handleGetEntriesData(results.data, show_id);
        })
    }

    handleGetEntriesData(response, show_id){
      if(response.show_data.show_closed){
        this.setState({
          class_selection_error_msg: 'Show is closed. You cannot add/drop classes.'
        });
        document.getElementById('step_1_warning').style.display = "block";
        document.getElementById('add_class_fields').style.display = "none";
      } else if(!response.can_add_drop_class){
        this.setState({
          class_selection_error_msg: 'You do not have permission to add/drop classes.'
        });
        document.getElementById('step_1_warning').style.display = "block";
        document.getElementById('add_class_fields').style.display = "none";
      } else {
        this.setState({
          class_selection_error_msg: ''
        });
        document.getElementById('step_1_warning').style.display = "none";
        document.getElementById('add_class_fields').style.display = "block";
      }
      var entry_id = this.getQueryVariable('entry_id');
      var entries_list = response.entries_data?response.entries_data:[];
      var selected_entry = {};
      var selected_entry_id = '-4';
      var rider_select_disabled = true;
      if (entry_id && entry_id != ''){

        var entry = entries_list.find(el => el.entry_id === entry_id);
        if (entry){
          selected_entry_id = entry_id;
          selected_entry = entry;
          rider_select_disabled = false;
          this.getSelectedClassesList(show_id, entry_id);

        }
      }
      this.setState({
        show_data: response.show_data,
        credit_hold: response.credit_hold?response.credit_hold:false,
        entries_list: response.entries_data?response.entries_data:[],
        selected_entry_id: selected_entry_id,
        selected_entry: entry,
        pending_requests_list: response.pending_requests?response.pending_requests[0]:[],
        rider_select_disabled:rider_select_disabled,
        txt_div_disabled:true,
        div_select_disabled:true,
        class_select_disabled:true,
        txt_class_disabled:true,
        restrict_junior_riders: response.restrict_junior_riders == '1'?true:false,

      });

    }

    getSelectedShowData(show_id){
      axios.get(this.sgl_webservice_iphone_entry+'GetShowData',{
        params : {
            show_id : show_id,
            company_id: this.context.company_id
        }
      }).then(results => {
        this.setState({
          divisions_list: results.data.divisions?results.data.divisions:[],
          divisions_filtered_list: results.data.divisions?results.data.divisions:[],
          classes_list: results.data.classes?results.data.classes:[],
          class_add_fee: results.data.class_add_fee?results.data.class_add_fee:'',
          class_add_fee_each: results.data.class_add_fee_each?results.data.class_add_fee_each:'',
          class_add_date: results.data.class_add_date?results.data.class_add_date:'',
          class_add_fee_time: results.data.class_add_fee_time?results.data.class_add_fee_time:'',
          class_add_fee_amount: results.data.class_add_fee_amount?results.data.class_add_fee_amount:'',
          charge_add_fee_on_web: results.data.charge_add_fee_on_web?results.data.charge_add_fee_on_web:false,
          class_drop_fee: results.data.class_drop_fee?results.data.class_drop_fee:'',
          class_drop_fee_each: results.data.class_drop_fee_each?results.data.class_drop_fee_each:'',
          class_drop_fee_date: results.data.class_drop_fee_date?results.data.class_drop_fee_date:'',
          class_drop_fee_time: results.data.class_drop_fee_time?results.data.class_drop_fee_time:'',
          class_drop_fee_amount: results.data.class_drop_fee_amount?results.data.class_drop_fee_amount:'',
          charge_drop_fee_on_web: results.data.charge_drop_fee_on_web?results.data.charge_drop_fee_on_web:false,
          // loading: false
        })    
      })
      
    }

    getSelectedClassesList(show_id, entry_id){
      axios.get(this.sgl_webservice_iphone_class+'ClassList',{
        params : {
            show_id : show_id,
            company_id: this.context.company_id,
            entry_id: entry_id
        }
      }).then(results => {
        var riders = results.data.entry_data.riders?results.data.entry_data.riders:[];
        // var rider_classes_list=[]
        riders.forEach(rider => {
          rider.add_class_numbers = [];
          rider.drop_class_numbers = [];
        });
        this.setState({
          riders_list: riders,
          selected_classes: results.data.entry_data.class_list?results.data.entry_data.class_list:[],
          entry_classes: results.data.entry_data.class_list?results.data.entry_data.class_list:[],
          entry_on_credit_hold: results.data.entry_on_credit_hold,
          entry_on_vet_hold: results.data.entry_on_vet_hold
        })    
      })
      
    }

    checkSelectClassToAdd(show_id, class_numbers, rider_id, horse_id, entry_id, is_change_rider=false){
      axios.get(this.sgl_webservice_iphone_class+'ClassAdd',{
        params : {
            show_id : show_id,
            class_numbers : class_numbers,
            entry_id: entry_id,
            rider_id : rider_id,
            horse_id : horse_id,
            company_id: this.context.company_id
        }
      }).then(results => {
        if (is_change_rider){
          this.setChangeRiderAddResponseData(results.data, class_numbers);
        } else {
          this.setClassResponseData(results.data);
        }
      })
    }

    checkSelectClassToDrop(show_id, class_numbers, rider_id, horse_id, entry_id, is_change_rider=false){
      axios.get(this.sgl_webservice_iphone_class+'ClassDrop',{
        params : {
            show_id : show_id,
            class_numbers : class_numbers,
            entry_id: entry_id,
            rider_id : rider_id,
            horse_id : horse_id,
            company_id: this.context.company_id
        }
      }).then(results => {
        if (is_change_rider){
          this.setChangeRiderDropResponseData(results.data, rider_id);
        } else {
          this.setDropClassResponseData(results.data, rider_id);
        }
      })
    }

    checkSelectDivisionToAdd(show_id, division_id, rider_id, horse_id){
      axios.get(this.sgl_webservice_iphone_entry+'SelectDivision',{
        params : {
            show_id : show_id,
            division_id : division_id,
            rider_id : rider_id,
            horse_id : horse_id,
            company_id: this.context.company_id
        }
      }).then(results => {
        this.setDivisionResponseData(results.data);
      })
    }

    saveClassAddDropApiCall(show_id, entry_id, rider_id, horse_id, class_numbers_to_add, class_numbers_to_drop, rider_classes) {
      axios.get(this.sgl_webservice_iphone_class+'saveClassAddDrop',{
        params : {
            show_id : show_id,
            entry_id: entry_id,
            // rider_id : rider_id,
            horse_id : horse_id,
            add_drop_class_data:rider_classes,
            // add_class_numbers : class_numbers_to_add,
            // drop_class_numbers : class_numbers_to_drop,
            company_id: this.context.company_id,
            sgl_plugin: true,
            team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
        }
      }).then(results => {
        this.setAddDropClassesResponseData(results.data);
      })
    }

    saveClassAddDrop = () => (e) => {
      document.getElementById('step_1_warning').style.display = "none";
      var rider_classes = [];
      this.state.riders_list.forEach(rider => {
        if(rider.add_class_numbers.length > 0 || rider.drop_class_numbers.length > 0){
          var rider_class = {
            "add_class_numbers": rider.add_class_numbers.join(','),
            "drop_class_numbers": rider.drop_class_numbers.join(','),
            "rider_id": rider.rider_id
          };
          rider_classes.push(rider_class);
        }

      });
      if(rider_classes.length > 0){
        this.saveClassAddDropApiCall(this.state.current_show, this.state.selected_entry_id, this.state.selected_rider_id, this.state.selected_entry.horse_id, this.state.class_numbers_to_add.join(','), this.state.class_numbers_to_drop.join(','), JSON.stringify(rider_classes));
      } else {
        this.setState({
          class_selection_error_msg: 'There are no changes to save.'
        });
        
        document.getElementById('step_1_warning').style.display = "block";
      }  
      
    }

    setAddDropClassesResponseData(response_data){
      if(response_data.add_drop_successful) {
        this.setState({
          pending_requests_list: response_data.pending_requests?response_data.pending_requests:[],
        });
        document.getElementById('add_drop_fields').style.display = "none";
        document.getElementById('save_button_div').style.display = "none";
        
        document.getElementById('add_drop_success_message').style.display = "block";
        window.removeEventListener('beforeunload', this.handleLeavePage);
      } else {
        if(response_data.add_drop_error && response_data.add_drop_error[0] && response_data.add_drop_error[0][0] && response_data.add_drop_error[0][0].error){
          this.setState({
            class_selection_error_msg: response_data.add_drop_error[0][0].error
          });
        } else {
          this.setState({
            class_selection_error_msg: 'There is some problem in saving your changes.'
          });
        }
        document.getElementById('step_1_warning').style.display = "block";
      }
    }

    onEntrySelect(e){
      this.resetChangeEntryState();
      if (e.target.value !== '-4'){
        const entry = this.state.entries_list.find(el => el.entry_id === e.target.value);

        this.setState({
          selected_entry_id: e.target.value,
          selected_entry: entry,
          rider_select_disabled:false,
        });
        this.getSelectedClassesList(this.state.current_show, e.target.value);
      } else {
        this.setState({
          selected_entry_id: e.target.value,
          selected_entry: {},
          rider_select_disabled:true,
        });
      }
    }

    onDivisionSelect(e){
      var division = {};
      if(e.target.value != '-1'){
        document.getElementById('select_div_msg').style.display = "block";
        division = this.state.divisions_list.find(el => el.division_id === e.target.value);
        division.is_change_rider = false;
        division.change_rider_option = '0';

      }
      this.setState({
        division_to_add: e.target.value,
        selected_division: division
      });
    }

    onClassSelect(e){
      if(e.target.value != '-1'){
        document.getElementById('select_class_msg').style.display = "block";
      }
      this.setState({
        class_to_add: e.target.value
      });
    }

    async onClassRiderSelect(e){

        if (e.target.value !== '-4'){
          // call api to get parent status
          this.setState({
            selected_rider_id: e.target.value,
            // div_select_disabled:false,
            // txt_div_disabled:false,
            // class_select_disabled:false,
            // txt_class_disabled:false,
          });
          let parent_verified = true
          let selected_rider = this.state.riders_list.find(r => r.rider_id == e.target.value);
        

          if (this.state.restrict_junior_riders && selected_rider && selected_rider.is_junior) {
            if (selected_rider.parent_guardian_id > 0) {
              // call api to get parent status
              try {
                const res = await this.getLinkedParents(selected_rider.rider_id, this.context.company_id);
                    parent_verified = res.data.linked_people? res.data.linked_people.some(lp => 
                      lp.people_id == selected_rider.parent_guardian_id &&
                      lp.peoplexpeople_id
                    ): false;
              } catch (err) {
                  console.error("Error fetching parent data:", err);
                  parent_verified = false;
                }
            } else {
              parent_verified = false;
            }
          } 
          if(parent_verified){
            this.setState({
              // selected_rider_id: e.target.value,
              div_select_disabled:false,
              txt_div_disabled:false,
              class_select_disabled:false,
              txt_class_disabled:false,
              parent_verified: true,
            });
          } else {
            this.setState({
              // selected_rider_id: e.target.value,
              div_select_disabled:true,
              txt_div_disabled:true,
              class_select_disabled:true,
              txt_class_disabled:true,
              parent_verified: false,
            });
          }

        }
    }

    updateDivisionSearch(evt) {
      this.setState({
        division_search: evt.target.value
      });
    }

    filterDivisionsList = () => (e) => {
      
      const divisions = this.state.divisions_list.filter((div) => div.name.toLowerCase().includes(this.state.division_search.toLowerCase()))
      // var class_ids = classes.map(s=>s.class_id);
      this.setState({
        divisions_filtered_list: divisions
      });
    }

    addDivision = () => (e) => {
        document.getElementById('step_1_warning').style.display = "none";
        document.getElementById('select_div_msg').style.display = "none";
        var rider = this.state.riders_list.find(c => c.rider_id === this.state.selected_rider_id);

        if (this.state.division_to_add != '-1'){
          if (this.state.entry_on_vet_hold){
            this.setState({
              class_selection_error_msg: 'The selected class(es) can not be added because entry is on vet hold. Please see the show office for assistance.'
            });
            
            document.getElementById('step_1_warning').style.display = "block";
          } else if (this.state.entry_on_credit_hold){
            this.setState({
              class_selection_error_msg: 'The selected class(es) can not be added because entry is on credit hold. Please see the show office for assistance.'
            });
            
            document.getElementById('step_1_warning').style.display = "block";
          } else if (rider.on_medical_hold){
            this.setState({
              class_selection_error_msg: 'The selected class(es) can not be added because rider is on medical hold. Please see the show office for assistance.'
            });
            
            document.getElementById('step_1_warning').style.display = "block";
          } else {

            this.checkSelectDivisionToAdd( this.state.current_show, this.state.division_to_add, this.state.selected_rider_id, this.state.selected_entry.horse_id);
            this.setState({
              division_to_add: '-1',
              // selected_division: {}
            });
          }
        }
    }

    addClass = () => (e) => {
      // if (this.state.selected_rider_id != '-4'){
        document.getElementById('step_1_warning').style.display = "none";
        document.getElementById('select_class_msg').style.display = "none";
        document.getElementById('enter_class_msg').style.display = "none";
        var rider = this.state.riders_list.find(c => c.rider_id === this.state.selected_rider_id);

        if (this.state.class_to_add != '-1'){
          if (this.state.entry_on_vet_hold){
            this.setState({
              class_selection_error_msg: 'The selected class(es) can not be added because entry is on vet hold. Please see the show office for assistance.'
            });
            
            document.getElementById('step_1_warning').style.display = "block";
          } else if (this.state.entry_on_credit_hold){
            this.setState({
              class_selection_error_msg: 'The selected class(es) can not be added because entry is on credit hold. Please see the show office for assistance.'
            });
            
            document.getElementById('step_1_warning').style.display = "block";
          } else if (rider.on_medical_hold){
            this.setState({
              class_selection_error_msg: 'The selected class(es) can not be added because rider is on medical hold. Please see the show office for assistance.'
            });
            
            document.getElementById('step_1_warning').style.display = "block";
          } else {
            var class_already_added = this.state.selected_classes.find(c => c.class_number === this.state.class_to_add);

            if (class_already_added){
              if (class_already_added.rider_id != this.state.selected_rider_id){

                  class_already_added.is_change_rider = false;
                  class_already_added.change_rider_option = '0';
                  
                  // change_rider_classes.push(class_already_added);
                  document.getElementById('change_rider_div').style.display = "block";
                  document.getElementById('step_4').style.display = "none";
                  this.setState({
                    change_rider_classes: [class_already_added],
                    change_div_rider: false
                  });

                // }
                
              }
            } else {
              // checking if class is locally deleted 
              var class_already_added = this.state.entry_classes.find(c => c.class_number === this.state.class_to_add && c.rider_id === this.state.selected_rider_id);
              if (class_already_added) {
                var rider = this.state.riders_list.find(c => c.rider_id === this.state.selected_rider_id);
                var numbers_to_drop = rider.drop_class_numbers.filter(x=> x != this.state.class_to_add);
                var drop_class_numbers = numbers_to_drop;

                // var add_numbers_list = rider.add_class_numbers.push(classs.number);

                // rider.add_class_numbers = rider.add_class_numbers.push(classs.number);
                this.setState(prevState => ({
                  selected_classes: [...prevState.selected_classes, class_already_added],
                  // classes_to_add: [...prevState.classes_to_add, classs],
                  // class_numbers_to_add: [...prevState.class_numbers_to_add, classs.number],
                  riders_list: prevState.riders_list.map(el => (el.rider_id === rider.rider_id ? { ...el, drop_class_numbers } : el)) 

                }))
              } else {
                this.checkSelectClassToAdd( this.state.current_show, this.state.class_to_add, this.state.selected_rider_id, this.state.selected_entry.horse_id, this.state.selected_entry_id);

              }
            } 
            this.setState({
              class_to_add: '-1'
            });
          }
        }
    }


    setClassNumberMsg() {
      document.getElementById('enter_class_msg').style.display = "block";
    }
    
    updateClassNumbers(evt) {
      var numbers = evt.target.value;
      // numbers = numbers.split(',').map(item => item.trim());

      this.setState({
        entry_numbers: numbers
      });
    }
    addClassesByNumber = () => (e) => {
      // if (this.state.selected_rider_id != '-4'){
        document.getElementById('step_1_warning').style.display = "none";
        document.getElementById('select_class_msg').style.display = "none";
        document.getElementById('enter_class_msg').style.display = "none";
        var rider = this.state.riders_list.find(c => c.rider_id === this.state.selected_rider_id);

        if (this.state.entry_on_vet_hold){
          this.setState({
            class_selection_error_msg: 'The selected class(es) can not be added because entry is on vet hold. Please see the show office for assistance.'
          });
          
          document.getElementById('step_1_warning').style.display = "block";
        } else if (this.state.entry_on_credit_hold){
          this.setState({
            class_selection_error_msg: 'The selected class(es) can not be added because entry is on credit hold. Please see the show office for assistance.'
          });
          
          document.getElementById('step_1_warning').style.display = "block";
        } else if (rider.on_medical_hold){
          this.setState({
            class_selection_error_msg: 'The selected class(es) can not be added because rider is on medical hold. Please see the show office for assistance.'
          });
          
          document.getElementById('step_1_warning').style.display = "block";
        } else {

          var change_rider_classes = [];
          var classes_to_add = [];

          var numbers = this.state.entry_numbers.split(',').map(item => item.trim());
          numbers.forEach(class_number => {
            var class_already_added = this.state.selected_classes.find(c => c.class_number === class_number);

            if (class_already_added){
              if (class_already_added.rider_id != this.state.selected_rider_id){

                  class_already_added.is_change_rider = false;
                  class_already_added.change_rider_option = '0';
                  change_rider_classes.push(class_already_added);              
              }
            } else {
              // checking if class is locally deleted 
              var class_already_added = this.state.entry_classes.find(c => c.class_number === class_number && c.rider_id === this.state.selected_rider_id);
              if (class_already_added) {
                var rider = this.state.riders_list.find(c => c.rider_id === this.state.selected_rider_id);
                var numbers_to_drop = rider.drop_class_numbers.filter(x=> x != class_number);
                var drop_class_numbers = numbers_to_drop;

                this.setState(prevState => ({
                  selected_classes: [...prevState.selected_classes, class_already_added],
                  riders_list: prevState.riders_list.map(el => (el.rider_id === rider.rider_id ? { ...el, drop_class_numbers } : el)) 

                }))
              } else {
                classes_to_add.push(class_number);
              }
            }
            
          });
          if (classes_to_add.length > 0){
            this.checkSelectClassToAdd( this.state.current_show, classes_to_add.join(','), this.state.selected_rider_id, this.state.selected_entry.horse_id, this.state.selected_entry_id);
          }
          if (change_rider_classes.length > 0){
            document.getElementById('change_rider_div').style.display = "block";
            document.getElementById('step_4').style.display = "none";
            this.setState({
              change_rider_classes: change_rider_classes,
              change_div_rider: false

            });
          }
        }

    }

    setDivisionResponseData(response_data){
      var error_msg = '';
      var change_rider_classes = [];
      var change_rider_flag = false;

      response_data.forEach(class_response => {
        if (!class_response.success) {
          error_msg += class_response.error + ' \n';
        }
      });
      if (error_msg != ''){
        this.setState({
          class_selection_error_msg: error_msg
        });
        
        document.getElementById('step_1_warning').style.display = "block";
      } else {
        response_data.forEach(class_response => {
          
            var classs = this.state.classes_list.find(c => c.class_id === class_response.class_id);
            var class_already_added = this.state.selected_classes.find(c => c.class_id === class_response.class_id);
            if (class_already_added){
              class_already_added = JSON.parse(JSON.stringify(class_already_added))
              if (class_already_added.rider_id != class_response.rider_id){
                change_rider_flag = true;
              }
              class_already_added.is_change_rider = false;
              class_already_added.change_rider_option = '0';
              change_rider_classes.push(class_already_added);              
              
            } else {
              var rider = this.state.riders_list.find(c => c.rider_id === class_response.rider_id);
              classs.rider_id = class_response.rider_id;
              classs.rider_name = rider.rider_name;
              classs.class_number = classs.number;
              classs.class_name = classs.name;
              classs.is_drop_allowed = true;
              var add_numbers_list = rider.add_class_numbers.push(classs.number);
              this.setState(prevState => ({
                selected_classes: [...prevState.selected_classes, classs],
                // classes_to_add: [...prevState.classes_to_add, classs],
                class_numbers_to_add: [...prevState.class_numbers_to_add, classs.number],
                riders_list: prevState.riders_list.map(el => (el.rider_id === rider.rider_id ? { ...el, add_numbers_list } : el)) 

              }))
            }   
        });
        if (change_rider_flag){
          document.getElementById('change_rider_div').style.display = "block";
          document.getElementById('step_4').style.display = "none";
          var division_to_change = this.state.selected_division;
          division_to_change.is_change_rider = false;
          division_to_change.change_rider_option = '0';

          this.setState({
            change_rider_classes: change_rider_classes,
            change_div_rider: true,
            selected_division: division_to_change
          });
        } else {
          this.setState({
            class_selection_error_msg: 'Please click Save button to submit the changes.'
          });
          document.getElementById('step_1_warning').style.display = "block";
  
        }
      }
    }

    setClassResponseData(response_data){
      var error_msg = '';
      var success_count = 0;
      // var change_rider_classes = [];
      var processed_classes = [];
      for(let i=0; i<response_data.length; i++){
        if (response_data[i].required && response_data[i].division_id && response_data[i].division_id > 0) {
          var already_processed = processed_classes.find(c => c.division_id === response_data[i].division_id);

          if(!already_processed){
            var div_classes = response_data.filter((c) => c.division_id === response_data[i].division_id);
            var errored_div = div_classes.find(c => c.success === false);
            if(errored_div){
              processed_classes.push(errored_div);
            } else {
              processed_classes = processed_classes.concat(div_classes);
            }
          }

        } else {
          processed_classes.push(response_data[i]);
        }
      }
      processed_classes.forEach(class_response => {          
          if (class_response.success) {
            success_count += 1;
            var classs = this.state.classes_list.find(c => c.class_id === class_response.class_id);
            const class_already_added = this.state.selected_classes.find(c => c.class_id === class_response.class_id && c.rider_id === class_response.rider_id);
            if (!class_already_added){
              var rider = this.state.riders_list.find(c => c.rider_id === class_response.rider_id);
              classs.rider_id = class_response.rider_id;
              classs.rider_name = rider.rider_name;
              classs.class_number = classs.number;
              classs.class_name = classs.name;
              classs.is_drop_allowed = true;

            
              var add_numbers_list = rider.add_class_numbers.push(classs.number);

              this.setState(prevState => ({
                selected_classes: [...prevState.selected_classes, classs],
                // classes_to_add: [...prevState.classes_to_add, classs],
                class_numbers_to_add: [...prevState.class_numbers_to_add, classs.number],
                riders_list: prevState.riders_list.map(el => (el.rider_id === rider.rider_id ? { ...el, add_numbers_list } : el)) 

              }))
            }
          } else {
            error_msg += class_response.error + ' \n';
          }
          
      });
      if (success_count > 0) {
          error_msg += 'Please click Save button to submit the changes.'        
      }
      this.setState({
        class_selection_error_msg: error_msg
      });
      document.getElementById('step_1_warning').style.display = "block";

    }

    setChangeRiderAddResponseData(response_data, class_numbers){
      var error_msg = '';
      var success_count = 0;
      // var change_rider_classes = [];
      var class_numbers_to_drop = [];
      var rider_classes_to_drop = {};
      var local_classes_to_drop = {};
      response_data.forEach(class_response => {          
          if (class_response.success) {
            var classs = this.state.change_rider_classes.find(c => c.class_number === class_numbers);
            // const class_already_added = this.state.selected_classes.find(c => c.class_id === class_response.class_id);
              success_count += 1;
              // checking if class exists in entry classes or was locally added
              var class_already_added = this.state.entry_classes.find(c => c.class_id === class_response.class_id && c.rider_id === classs.rider_id);

              if(class_already_added){
                if (rider_classes_to_drop[classs.rider_id]){
                  rider_classes_to_drop[classs.rider_id].push(class_response.number);
                } else {
                  rider_classes_to_drop[classs.rider_id] = [class_response.number];
                }
              } else {
                if (local_classes_to_drop[classs.rider_id]){
                  local_classes_to_drop[classs.rider_id].push(class_response.number);
                } else {
                  local_classes_to_drop[classs.rider_id] = [class_response.number];
                }
              } 
          } else {
            error_msg += class_response.error + ' \n';
          }
          
      });
      if (success_count > 0) {
        Object.keys(rider_classes_to_drop).map(function(rider_id) {
          class_numbers_to_drop = rider_classes_to_drop[rider_id].join(',');
          
          this.checkSelectClassToDrop( this.state.current_show, class_numbers_to_drop, rider_id, this.state.selected_entry.horse_id, this.state.selected_entry_id, true);
        }, this);
        Object.keys(local_classes_to_drop).map(function(rider_id) {
          class_numbers_to_drop = local_classes_to_drop[rider_id];
          
          this.changeRider(class_numbers_to_drop, this.state.selected_rider_id, rider_id);
        }, this);
        

      } 
      if(error_msg != '') {
        this.setState({
          class_selection_error_msg: error_msg
        });
        document.getElementById('step_1_warning').style.display = "block";
      }
    }

    dropClass = (class_number, rider_id) => {
      var rider = this.state.riders_list.find(c => c.rider_id === rider_id);
      var numbers_to_add = rider.add_class_numbers.filter(x=> x !== class_number);
      var add_class_numbers = numbers_to_add;

      this.setState(prevState => ({
        selected_classes: prevState.selected_classes.filter(c => !(c.class_number === class_number && c.rider_id === rider_id)),
        riders_list: prevState.riders_list.map(el => (el.rider_id === rider_id ? { ...el, add_class_numbers } : el)) ,
        class_numbers_to_add: prevState.class_numbers_to_add.filter(num => num !== class_number),
        class_selection_error_msg: 'Please click Save button to submit the changes.'
      }));
      document.getElementById('step_1_warning').style.display = "block";


    }

    setDropClassResponseData(response_data, rider_id){
      var rider = this.state.riders_list.find(c => c.rider_id === rider_id);

      response_data.forEach(class_data => {
        if(class_data.success){
          this.dropClass(class_data.number, rider_id);

          var drop_numbers_list = rider.drop_class_numbers;
          drop_numbers_list.push(class_data.number);
          var drop_class_numbers = drop_numbers_list;

          this.setState(prevState => ({
            classes_to_drop: [...prevState.classes_to_drop, class_data],
            class_numbers_to_drop: [...prevState.class_numbers_to_drop, class_data.number],
            riders_list: prevState.riders_list.map(el => (el.rider_id === rider.rider_id ? { ...el, drop_class_numbers } : el))
          }))
          this.setState({
            class_selection_error_msg: 'Please click Save button to submit the changes.'
          });          
          document.getElementById('step_1_warning').style.display = "block";
          // this.state.class_numbers_to_drop.push(class_data.number);
        } else {
          this.setState({
            class_selection_error_msg: class_data.error
          });          
          document.getElementById('step_1_warning').style.display = "block";
        }
      })
    }

    setChangeRiderDropResponseData(response_data, rider_id){
      // var rider = this.state.riders_list.find(c => c.rider_id === rider_id);
      var class_numbers_list = [];
      var error_msg = "";

      response_data.forEach(class_data => {
        if(class_data.success){
          class_numbers_list.push(class_data.number);

          var old_rider = this.state.riders_list.find(c => c.rider_id === rider_id);

          var drop_numbers_list = old_rider.drop_class_numbers;
          drop_numbers_list.push(class_data.number);
          var drop_class_numbers = drop_numbers_list;

          this.setState(prevState => ({
            // classes_to_drop: [...prevState.classes_to_drop, class_data],
            class_numbers_to_drop: [...prevState.class_numbers_to_drop, class_data.number],
            riders_list: prevState.riders_list.map(el => (el.rider_id === old_rider.rider_id ? { ...el, drop_class_numbers } : el))
          }))
          
          // this.state.class_numbers_to_drop.push(class_data.number);
        } else {
          error_msg += response_data.error + '\n';
          
        }
      })
      if (class_numbers_list.length > 0){
        
        this.changeRider(class_numbers_list, this.state.selected_rider_id, rider_id)
      } else {
          this.setState({
            class_selection_error_msg: response_data.error
          });          
          document.getElementById('step_1_warning').style.display = "block";
      }
    }

    changeRider(class_numbers_list, new_rider_id, old_rider_id){
      var old_rider = this.state.riders_list.find(c => c.rider_id === old_rider_id);
      var new_rider = this.state.riders_list.find(c => c.rider_id === new_rider_id);

      // this.dropClass(class_data.number, old_rider_id);
      class_numbers_list.forEach(class_number => {
        //////////// drop class for olde rider ////////

        this.dropClass(class_number, old_rider_id);
        //////////// drop class for old rider end////////
        //////////// add class for new rider ////////
      
        //   var rider = this.state.riders_list.find(c => c.rider_id === class_response.rider_id);
        var classs = this.state.classes_list.find(c => c.number === class_number);
        classs.rider_id = new_rider.rider_id;
        classs.rider_name = new_rider.rider_name;
        classs.class_number = classs.number;
        classs.class_name = classs.name;
        classs.is_drop_allowed = true;

        // if (!class_already_added){
        var add_numbers_list = new_rider.add_class_numbers.push(classs.number);

        // rider.add_class_numbers = rider.add_class_numbers.push(classs.number);
        this.setState(prevState => ({
          selected_classes: [...prevState.selected_classes, classs],
          // classes_to_add: [...prevState.classes_to_add, classs],
          class_numbers_to_add: [...prevState.class_numbers_to_add, classs.number],
          riders_list: prevState.riders_list.map(el => (el.rider_id === new_rider.rider_id ? { ...el, add_numbers_list } : el)) 

        }))
        //////////// add class for new rider end ////////

      });
    }

    dropClassByNumber = (class_number, rider_id) => {
      
      const class_already_exists = this.state.entry_classes.find(c => c.class_number === class_number && c.rider_id === rider_id);

      if (class_already_exists){
        this.checkSelectClassToDrop( this.state.current_show, class_number, rider_id, this.state.selected_entry.horse_id, this.state.selected_entry_id);
      } else {
        this.dropClass(class_number, rider_id);
      }
    }

    dropClassesByNumber = () => (e) => {  
      document.getElementById('step_1_warning').style.display = "none";
      document.getElementById('enter_class_msg').style.display = "none";    
      if (this.state.entry_numbers && this.state.entry_numbers != ''){
        var class_numbers_to_drop = [];
        var numbers = this.state.entry_numbers.split(',').map(item => item.trim());

        numbers.forEach(class_number => {
          const class_already_exists = this.state.entry_classes.find(c => c.class_number === class_number && c.rider_id === this.state.selected_rider_id);
          if (class_already_exists){
            class_numbers_to_drop.push(class_number);
          } else {
            this.dropClass(class_number, this.state.selected_rider_id);
            // this.state.class_numbers_to_add
          }
        });

        this.checkSelectClassToDrop( this.state.current_show, class_numbers_to_drop.join(','), this.state.selected_rider_id, this.state.selected_entry.horse_id, this.state.selected_entry_id);
      }

    }

    getUserData(){
      axios.get(this.user_info_url)
      .then((response) => {
        this.context.checkLoginOnSGL();
        if(response.data.user && response.data.user != null){
          this.setState({
            userData : response.data.user,
          });
        }else{
        }
      }, (error) => {
      });
    }

    setChangeRider = (event) => {

    // setChangeRider = (class_data) => (e) => {
      var target_values = event.currentTarget.value.split('_');
      var class_number = target_values[0];
      // var class_data = this.state.change_rider_classes.find(c => c.class_number === class_number);
      var is_change_rider = false;
      var change_rider_option = target_values[1]

      if(target_values[1] === '1'){
        is_change_rider = true;
      }
      this.setState(prevState => ({
        change_rider_classes: prevState.change_rider_classes.map(el => (el.class_number === class_number ? { ...el, is_change_rider, change_rider_option } : el))
      }))
      // class_data.is_change_rider = event.currentTarget.value;

    }
    setChangeDivRider = (event) => {

      // setChangeRider = (class_data) => (e) => {
        var target_values = event.currentTarget.value.split('_');
        var class_number = target_values[0];
        // var class_data = this.state.change_rider_classes.find(c => c.class_number === class_number);
        var is_change_rider = false;
        var change_rider_option = target_values[1];

        if(target_values[1] === '1'){
          is_change_rider = true;
        }
        var div = this.state.selected_division;
        div.is_change_rider = is_change_rider;
        div.change_rider_option = change_rider_option;
        this.setState({
          selected_division : div
        });
          
    }

    change_rider_selected = () => (e) => {
        this.state.change_rider_classes.forEach(rider_class => {
          if (rider_class.change_rider_option === '1' || rider_class.change_rider_option === '2'){
            const class_already_exists = this.state.entry_classes.find(c => c.class_number === rider_class.class_number && c.rider_id === this.state.selected_rider_id);

            if (class_already_exists){
              if (rider_class.change_rider_option === '1'){
                this.dropClass(rider_class.class_number, rider_class.rider_id);
                var old_rider = this.state.riders_list.find(c => c.rider_id === rider_class.rider_id);
                var numbers_to_add = old_rider.add_class_numbers.filter(x=> x != rider_class.class_number);
                var add_class_numbers = numbers_to_add;

                this.setState(prevState => ({
                  riders_list: prevState.riders_list.map(el => (el.rider_id === old_rider.rider_id ? { ...el, add_class_numbers } : el)) 

                }))

              } 
              var rider = this.state.riders_list.find(c => c.rider_id === this.state.selected_rider_id);
              var numbers_to_drop = rider.drop_class_numbers.filter(x=> x != rider_class.class_number);
              var drop_class_numbers = numbers_to_drop;
              this.setState(prevState => ({
                selected_classes: [...prevState.selected_classes, class_already_exists],
                riders_list: prevState.riders_list.map(el => (el.rider_id === rider.rider_id ? { ...el, drop_class_numbers } : el)) 

              }))

            } else {
              if (rider_class.change_rider_option === '1'){
                this.checkSelectClassToAdd( this.state.current_show, rider_class.class_number, this.state.selected_rider_id, this.state.selected_entry.horse_id, this.state.selected_entry_id, true);

              } else {
                this.checkSelectClassToAdd( this.state.current_show, rider_class.class_number, this.state.selected_rider_id, this.state.selected_entry.horse_id, this.state.selected_entry_id);
              }
            }
          }
          
        });
        
        document.getElementById('change_rider_div').style.display = "none";
        document.getElementById('step_4').style.display = "block";
    }

    change_div_rider_selected = () => (e) => {
      if (this.state.selected_division.change_rider_option === '1' || this.state.selected_division.change_rider_option === '2'){
        var class_numbers_to_drop = [];
        var selcted_class_ids = [];
        var local_riders_list = JSON.parse(JSON.stringify(this.state.riders_list));

        this.state.change_rider_classes.forEach(rider_class => {
          // if (rider_class.is_change_rider){
            if (this.state.selected_division.change_rider_option === '1'){
              const class_already_exists = this.state.entry_classes.find(c => c.class_number === rider_class.class_number && c.rider_id === rider_class.rider_id);
              if (class_already_exists){
                selcted_class_ids.push({
                  'number':rider_class.class_number,
                  'rider_id':rider_class.rider_id,
                })
                // this.checkSelectClassToDrop( this.state.current_show, rider_class.class_number, rider_class.rider_id, this.state.selected_entry.horse_id, this.state.selected_entry_id);

                class_numbers_to_drop.push(rider_class.class_number);

              } else {
                const class_already_exists = this.state.entry_classes.find(c => c.class_number === rider_class.class_number && c.rider_id === this.state.selected_rider_id);
                
                var old_rider = local_riders_list.find(c => c.rider_id === rider_class.rider_id);
                var numbers_to_add = old_rider.add_class_numbers.filter(x=> x != rider_class.class_number);
                var add_class_numbers = numbers_to_add;
                local_riders_list = local_riders_list.map(el => (el.rider_id === old_rider.rider_id ? { ...el, add_class_numbers } : el))


                this.setState(prevState => ({
                  selected_classes: prevState.selected_classes.filter(c => !(c.class_number === rider_class.class_number && c.rider_id === old_rider.rider_id)),
                  // classes_to_add: prevState.classes_to_add.filter(c => c.class_number !== class_number),
                  // riders_list: prevState.riders_list.map(el => (el.rider_id === rider_id ? { ...el, add_class_numbers } : el)) ,
                }));
                
                if(class_already_exists) {
                  // this.dropClass(rider_class.class_number, rider_class.rider_id);
                  var rider = local_riders_list.find(c => c.rider_id === this.state.selected_rider_id);
                  var numbers_to_drop = rider.drop_class_numbers.filter(x=> x != rider_class.class_number);
                  var drop_class_numbers = numbers_to_drop;
                  local_riders_list = local_riders_list.map(el => (el.rider_id === rider.rider_id ? { ...el, drop_class_numbers } : el))

                  this.setState(prevState => ({
                    selected_classes: [...prevState.selected_classes, class_already_exists],
                    
                  }))
                  

                } else {
                  var rider = local_riders_list.find(c => c.rider_id === this.state.selected_rider_id);
                  var new_rider_class = JSON.parse(JSON.stringify(rider_class));
                  new_rider_class.rider_id = rider.rider_id;
                  new_rider_class.rider_name = rider.rider_name;
                  var add_numbers_list = rider.add_class_numbers.push(new_rider_class.class_number);
                  local_riders_list = local_riders_list.map(el => (el.rider_id === rider.rider_id ? { ...el, add_numbers_list } : el))

                  this.setState(prevState => ({
                    selected_classes: [...prevState.selected_classes, new_rider_class],
                    class_numbers_to_add: [...prevState.class_numbers_to_add, new_rider_class.class_number],

                  }))
                }
              }
            } else {
              /////////////////////
              var rider = local_riders_list.find(c => c.rider_id === this.state.selected_rider_id);
              var new_rider_class = JSON.parse(JSON.stringify(rider_class))
              new_rider_class.rider_id = rider.rider_id;
              new_rider_class.rider_name = rider.rider_name;
              var add_numbers_list = rider.add_class_numbers.push(new_rider_class.class_number);
              local_riders_list = local_riders_list.map(el => (el.rider_id === rider.rider_id ? { ...el, add_numbers_list } : el))

              this.setState(prevState => ({
                selected_classes: [...prevState.selected_classes, new_rider_class],
                class_numbers_to_add: [...prevState.class_numbers_to_add, new_rider_class.class_number],

              }))
            } 
        });

        this.setState(prevState => ({
          riders_list: local_riders_list
        }))

          var rider_classes = {};
          selcted_class_ids.forEach(element => {
            if (rider_classes[element.rider_id]){
              rider_classes[element.rider_id].push(element.number);
            } else {
              rider_classes[element.rider_id] = [element.number];
            }
            
          });

          Object.keys(rider_classes).map(function(rider_id) {
            class_numbers_to_drop  = rider_classes[rider_id].join(',');
            
            this.checkSelectClassToDrop( this.state.current_show, class_numbers_to_drop, rider_id, this.state.selected_entry.horse_id, this.state.selected_entry_id, true);
          }, this);

      }
     
      document.getElementById('change_rider_div').style.display = "none";
      document.getElementById('step_4').style.display = "block";

  }

    getPendingClassesList(entry_data){
      return <td>
        {(entry_data.add_class_numb_name_list.length > 0 ) &&
          <ul>
            <li className='class_list_li'><b>Classes Added:</b></li>
            {entry_data.add_class_numb_name_list.map((item)=>
            <li className='class_list_li'>{item}</li>)}
          </ul>
        }
        {(entry_data.drop_class_numb_name_list.length > 0 ) &&
          <ul>
            <li className='class_list_li'><b>Classes Dropped:</b></li>
            {entry_data.drop_class_numb_name_list.map((item)=>
            <li className='class_list_li'>{item}</li>)}
          </ul>
        }
      </td>
    }

    format_currancy(amount){
      if(amount === undefined){
        return '';
      }
      // return '$'+(amount && amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
      return '$'+(amount && Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));

    }

    format_date(unformatted_date){
      var unformatted_date_split = (unformatted_date && unformatted_date.split)?unformatted_date.split('T')[0]:unformatted_date;
      var formatted_date = (new Date(unformatted_date_split));
      formatted_date = new Date(formatted_date.toISOString().slice(0, -1));
      return parseInt(formatted_date.getMonth()+1) +"/"+ formatted_date.getDate() +"/"+ formatted_date.getFullYear();
    }

    format_time(timeString) {
      var H = +timeString.substr(0, 2);
      var h = H % 12 || 12;
      var ampm = H < 12 || H === 24 ? " AM" : " PM";
      timeString = h + timeString.substr(2, 3) + ampm;
      return timeString;
    }
     getLinkedParents(peopleId, customerId, field = 'rider') {
      if (!peopleId || !customerId) {
        return Promise.resolve({ linked_people: [], pending_linked_people: [] });
      }

      return axios.get('add-entry/getLinkedParentsFromCloud', {
          params: {
            people_id: peopleId,
            customer_id: customerId,
          }
        })
        .then(response => response.data || { linked_people: [], pending_linked_people: [] })
        .catch(error => {
          console.error('Error fetching linked parents:', error);
          return { linked_people: [], pending_linked_people: [] };
        });
    }
    render(){
        const loading = this.state.loading;

        if(loading) {
            return null;
        }

        if(this.state.switch_allowed != 1){
          return(
            <div>
              <h2>Class Add/Drop</h2>
              <p>{this.state.switch_company_name + ' does not support this feature.'}</p>
            </div>
          )
        }
    

        return(
            <div className="sgl-plugin addDropClassCss add-entry-page">
              {(this.state.credit_hold) ?
                <div id='checkout_redirect'>
                    <div id='credit_hold_warning'>
                        <p>Your account is currently on credit hold.  To continue please provide payment for your unpaid balances.</p>
                    </div>
                    {/* <p>Your account is currently on credit hold.  To continue please provide payment for your unpaid balances.</p> */}
                    <button className='sgl-button' >
                        <Link to='/checkout-entries' className="button-link">Pay Now</Link>
                    </button>
                </div>
              :
              <div>

                {/* <h2>Add Drop Class</h2> */}
                <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br />
                <div id="ringWrapper" className='ringWrapper'>
                        
                    <div className="div-responsive">

                      {/* add/drop class step 1 - Add/Drop classes */}
                        <button id='trainer_button_mobile' className='sgl-button trainer_button'>
                          {/* Trainer Add/Drop */}
                          <Link to='/trainer-add-drop' className="button-link">Trainer Add/Drop</Link>

                        </button>
                    
                        <div id="step_1_container" className='sgl-primary-header class-details primary-header class-details-header sgl-primary-header active_block'>
                            <p id="step_1_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name ">Class Add/Drop</p>
                            
                        </div>
                        <div id='step_4' className='add_entry_class add-entry-div'> 
                            <div id='add_drop_success_message' className='display_none'>
                              <span>Your class add/drop request has been completed. The changes will be applied in the show office shortly and an email confirming this request has been sent to {this.state.userData.email_address}. A second email will be sent once the change is completed.</span>
                            </div>
                            
                            <ul id='add_drop_fields'>
                              <li id="EntryRow" className='entry_people_li'>
                              {/* <div> */}
                                  <button id='trainer_button_desktop' className='sgl-button float_right'>
                                    <Link to='/trainer-add-drop' className="button-link">Trainer Add/Drop</Link>
                                  </button>
                                {/* </div> */}
                                <label className="add_entry_label width_fit_content">Select an Entry</label>
                                <div style={{clear: "both"}}></div>
                                <div className="people_selection_div">
                                        <select id="class_rider" className="input-height class_selection" value={this.state.selected_entry_id} onChange={(e) => this.onEntrySelect(e)}>
                                            <option value="-4">Select Entry...</option>
                                            {
                                              this.state.entries_list.map((entry,index) => {
                                              return (
                                                  <option value={`${entry.entry_id}`} key={entry.entry_id}>
                                                      {entry.number} - {(entry.trainer_account)?'TRAINER ACCOUNT':entry.horse}
                                                  </option>
                                              )
                                              })
                                            }
                                        </select>
                                </div>
                                
                                <div style={{clear: "both"}}></div>
                              </li>
                              <div id='add_class_fields'>
                                <li id="RiderRow" className='entry_people_li'>
                                  <label className="add_entry_label">Select Rider</label>
                                  <div style={{clear: "both"}}></div>
                                  <div className="people_selection_div">

                                    <select id="class_rider" className={["input-height class_selection", this.state.rider_select_disabled ? 'disable_cursor' : ''].join(' ')} value={this.state.selected_rider_id} disabled={this.state.rider_select_disabled} onChange={(e) => this.onClassRiderSelect(e)}>
                                        <option value="-4">Select Rider...</option>
                                        {
                                          this.state.riders_list.map((person,index) => {
                                          return (
                                              <option value={`${person.rider_id}`} key={person.rider_id}>
                                                  {person.rider_name}
                                              </option>
                                          )
                                          })
                                        }
                                    </select>
                                  </div>
                                  <div style={{clear: "both"}}></div>
                                </li>
                                <li id="FilterDivisionRow" className='entry_people_li'>
                                  <div style={{clear: "both"}}></div>

                                  <label className="add_entry_label">Add Division</label>
                                  {/* <hr className='hr_divider'/> */}
                                  <div style={{clear: "both"}}></div>

                                  <div className="people_selection_div">
                                    <input  className={["input-height input-text class_selection", this.state.txt_div_disabled ? 'disable_cursor' : ''].join(' ')} value={this.state.division_search} disabled={this.state.txt_div_disabled} type="text" name="txtFilterDivision" id="txtFilterDivision" onChange={evt => this.updateDivisionSearch(evt)}/>
                                  </div>
                                  <button  className="sgl-button search_button" type="button" title="Search" id="divisionFilter" name="divisionFilter"  onClick={this.filterDivisionsList()}>
                                      Search
                                  </button>
                                </li>
                                <li id="DivisionRow" className='entry_people_li'>
                                  <div style={{clear: "both"}}></div>
                                  <div className="people_selection_div">
                                      {/* <div className="input-box"> */}
                                          <select id="division" className={["input-height class_selection", this.state.div_select_disabled ? 'disable_cursor' : ''].join(' ')} disabled={this.state.div_select_disabled} value={this.state.division_to_add} onChange={(e) => this.onDivisionSelect(e)}>
                                              <option value="-1">Select Division...</option>
                                              {
                                                  this.state.divisions_filtered_list
                                                  .sort((a, b) => a.name.localeCompare(b.name))
                                                  .map((division,index) => {
                                                  return (
                                                      <option value={`${division.division_id}`} key={division.division_id}>
                                                          {division.name}
                                                      </option>
                                                  )
                                                  })
                                              }
                                          </select>
                                      {/* </div> */}
                                  </div>
                                  <button  className="sgl-button search_button" type="button" title="Add" onClick={this.addDivision()}>
                                      Add
                                  </button>
                                </li>
                                <li className='entry_people_li'>
                                  <div id='select_div_msg' className='display_none'>
                                    <span className='required'>Please click 'Add' button to select this division.</span>
                                  </div>
                                </li>
                                <li id="ClassRow" className='entry_people_li'>
                                  <div style={{clear: "both"}}></div>
                                  <label className="add_entry_label">Add Class</label>
                                  <div style={{clear: "both"}}></div>
                                  <div className="people_selection_div">
                                      {/* <div className="input-box"> */}
                                          <select id="class_list" className={["input-height class_selection", this.state.class_select_disabled ? 'disable_cursor' : ''].join(' ')} disabled={this.state.class_select_disabled} value={this.state.class_to_add} onChange={(e) => this.onClassSelect(e)}>
                                              <option value="-1">Select Class...</option>
                                              {
                                                this.state.classes_list
                                                .sort((a, b) => (a.number === 0) - (b.number === 0) || a.number - b.number)
                                                .map((classs,index) => {
                                                return (
                                                    <option value={`${classs.number}`} key={classs.class_id}>
                                                        {classs.number} - {classs.name}
                                                    </option>
                                                )
                                                })
                                              }
                                          </select>
                                      {/* </div> */}
                                  </div>
                                  <button className="sgl-button search_button" type="button" title="add" onClick={this.addClass()}>
                                      Add
                                  </button>
                                </li>
                                <li className='entry_people_li'>
                                  <div id='select_class_msg' className='display_none'>
                                    <span className='required'>Please click 'Add' button to select this class.</span>
                                  </div>
                                </li>
                                <li id="EnterClassRow" className='entry_people_li'>
                                  <div style={{clear: "both"}}></div>
                                  <label className="add_entry_label"> Enter Classes</label>
                                  {/* <hr className='hr_divider'/> */}
                                  <div style={{clear: "both"}}></div>
                                  <div className="people_selection_div">
                                    <input className={["input-height input-text class_selection", this.state.txt_class_disabled ? 'disable_cursor' : ''].join(' ')} 
                                      value={this.state.entry_numbers} disabled={this.state.txt_class_disabled} 
                                      type="text" name="txtEnterClass" id="txtEnterClass" 
                                      onChange={evt => this.updateClassNumbers(evt)} 
                                      onBlur={this.setClassNumberMsg.bind(this)}
                                    />

                                  </div>
                                  <button  className="sgl-mr-5 sgl-button search_button" type="button" title="Search" onClick={this.addClassesByNumber()}>
                                      Add
                                  </button>
                                  <button  className="drop_button sgl-button search_button" type="button" title="Search" onClick={this.dropClassesByNumber()}>
                                      Drop
                                  </button>
                                </li>
                                <li className='entry_people_li'>
                                  <div id='enter_class_msg' className='display_none'>
                                    <span className='required'>Please click 'Add' button to select this class.</span>
                                  </div>
                                </li>
                              </div>
                              {(this.state.charge_add_fee_on_web && this.state.class_add_fee_amount > 0) &&
                                <li className='entry_people_li'>
                                  <div style={{clear: "both"}}></div>
                                  <div id='class_add_amount' className='new-line required'>
                                    {(this.state.class_add_fee_each)?
                                      <p>After {this.format_date(this.state.class_add_date)} {this.format_time(this.state.class_add_fee_time)} you will be charged an additional fee of ${this.state.class_add_fee_amount} per class add operation.</p>
                                    :
                                      <p>After {this.format_date(this.state.class_add_date)} {this.format_time(this.state.class_add_fee_time)} you will be charged an additional fee of ${this.state.class_add_fee_amount} for class add operation.</p>
                                    }
                                      </div>
                                </li>
                              }
                              
                              {(this.state.charge_drop_fee_on_web && this.state.class_drop_fee_amount > 0 ) &&
                                <li className='entry_people_li'>
                                  <div style={{clear: "both"}}></div>
                                  <div id='class_drop_amount' className='new-line required'>
                                    {(this.state.class_drop_fee_each)?
                                      <p>After {this.format_date(this.state.class_drop_fee_date)} {this.format_time(this.state.class_drop_fee_time)} you will be charged an additional fee of ${this.state.class_drop_fee_amount} per class drop operation.</p>
                                    :
                                      <p>After {this.format_date(this.state.class_drop_fee_date)} {this.format_time(this.state.class_drop_fee_time)} you will be charged an additional fee of ${this.state.class_drop_fee_amount} for class drop operation.</p>
                                    }
                                      </div>
                                </li>
                              }
                              {this.state.parent_verified === false && this.state.selected_rider_id &&
                                <li className='entry_people_li'>
                                  <div style={{clear: "both"}}></div>
                                  <div id='parent_not_verified' className='new-line required'>
                                    <p>The selected rider's parent/guardian has not been confirmed. You cannot add/drop classes until verification is complete.</p>
                                  </div>
                                </li>
                              }
                              <li className='entry_people_li'>
                                <div id='step_1_warning' className='new-line required display_none' dangerouslySetInnerHTML={{ __html: this.state.class_selection_error_msg }}></div>
                              </li>
                              
                              <li className='entry_people_li'>

                                    <table className="table table-striped table-hover">
                                      <thead className="classes-header">
                                        <tr className="sgl-primary-header">
                                          <th>Your Classes</th>
                                          <th >&nbsp;</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                      { 
                                        this.state.selected_classes
                                        .sort((a, b) => (a.class_number === 0) - (b.class_number === 0) || a.class_number - b.class_number)
                                        .map((data, index) => {
                                          return (
                                            <tr className="" key={data.class_id}>
                                              <td>
                                                {data.class_number} {data.class_name} [{data.rider_name}]
                                                { (!data.is_drop_allowed) && <text className='required'>{'\n['+data.drop_error+']'}</text>}
                                              </td>
                                              { (data.is_drop_allowed) ? 
                                                <td className='center-align'><img src={delete_image} className="placing-icon add-entry-trash-icon" onClick={() => this.dropClassByNumber(data.class_number, data.rider_id)}/></td>
                                              :
                                                <td></td>
                                              }
                                              </tr>
                                          )
                                        })
                                      }
                                      </tbody>
                                </table>

                              </li>
                              <li className='entry_people_li'>
                                  <p>Click <img src={delete_image} className="placing-icon add-entry-trash-icon" /> To Remove Class</p>
                              </li>
                            </ul>
                            <div id='save_button_div' className='continue-button-div'>
                              
                              <button className='sgl-button' onClick={this.saveClassAddDrop()}>
                                Save
                              </button>
                            </div>
                        </div>
                        
                      {/* add/drp class - change/add rider */}
                        <div id='change_rider_div' className='add_entry_class add-entry-div display_none'>
                            <ul>
                              <li className='entry_people_li'>
                                <p>Selected Entry has multiple riders participating in the same class:</p>
                              </li>

                              <li className='entry_people_li'>
                                  {/* { (this.state.pending_requests_list.length > 0) && */}
                                    <table className="table table-striped table-hover">
                                      <thead className="classes-header">
                                        <tr className="sgl-primary-header">
                                          <th>{this.state.change_div_rider?'Division Detail':'Class List'}</th>
                                          <th >Existing Rider</th>
                                          <th >Cancel</th>
                                          {this.state.show_data.allow_multi_rider_add_class &&
                                            <th>Add</th>
                                          }
                                          <th>Change</th>

                                        </tr>
                                      </thead>
                                      { (this.state.change_div_rider) ? 
                                        <tbody>
                                          <tr className="">
                                            <td>{this.state.selected_division.name}</td>
                                            <td></td>
                                            <td className='center-align'>
                                              <input type="radio" name={this.state.selected_division.division_id+"_change"} 
                                                  value={this.state.selected_division.division_id+"_0"} 
                                                  checked={this.state.selected_division.change_rider_option === '0'} 
                                                  onChange={this.setChangeDivRider}
                                                  // disabled={show.no_add_entry}
                                              />
                                            </td>
                                            {this.state.show_data.allow_multi_rider_add_class &&
                                              <td className='center-align'>
                                                <input type="radio" name={this.state.selected_division.division_id+"_change"} 
                                                  value={this.state.selected_division.division_id+"_2"} 
                                                  checked={this.state.selected_division.change_rider_option === '2'} 
                                                  onChange={this.setChangeDivRider}
                                                  // disabled={show.no_add_entry}
                                                />
                                              </td>
                                            }
                                            <td className='center-align'>
                                              <input type="radio" name={this.state.selected_division.division_id+"_change"} 
                                                  value={this.state.selected_division.division_id+"_1"} 
                                                  checked={this.state.selected_division.change_rider_option === '1'} 
                                                  onChange={this.setChangeDivRider}
                                                  // disabled={show.no_add_entry}
                                              />
                                            </td>

                                          </tr>
                                          { this.state.change_rider_classes.map((data, index) => {
                                            return (
                                              <tr className="" key={data.class_id}>
                                                <td>{data.class_number} - {data.class_name}</td>
                                                <td>{data.rider_name}</td>
                                                <td className='center-align'>
                                                </td>
                                                {this.state.show_data.allow_multi_rider_add_class &&
                                                  <td className='center-align'>
                                                  </td>
                                                }
                                                <td className='center-align'>
                                                </td>

                                              </tr>
                                            )
                                          })}
                                        </tbody>
                                      :
                                        <tbody>
                                          { this.state.change_rider_classes.map((data, index) => {
                                            return (
                                              <tr className="" key={data.class_id}>
                                                <td>{data.class_number} - {data.class_name}</td>
                                                <td>{data.rider_name}</td>
                                                <td className='center-align'>
                                                  <input type="radio" name={data.class_number+"_change"} 
                                                      value={data.class_number+"_0"} 
                                                      checked={data.change_rider_option === '0'} 
                                                      onChange={this.setChangeRider}
                                                      // disabled={show.no_add_entry}
                                                  />
                                                </td>
                                                {this.state.show_data.allow_multi_rider_add_class &&
                                                  <td className='center-align'>
                                                    <input type="radio" name={data.class_number+"_change"} 
                                                      value={data.class_number+"_2"} 
                                                      checked={data.change_rider_option === '2'} 
                                                      onChange={this.setChangeRider}
                                                      // disabled={show.no_add_entry}
                                                    />
                                                  </td>
                                                }
                                                <td className='center-align'>
                                                  <input type="radio" name={data.class_number+"_change"} 
                                                      value={data.class_number+"_1"} 
                                                      checked={data.change_rider_option === '1'} 
                                                      onChange={this.setChangeRider}
                                                      // disabled={show.no_add_entry}
                                                  />
                                                </td>

                                              </tr>
                                            )
                                          })}
                                        </tbody>
                                      }
                                    </table>
                                  {/* } */}

                              </li>
                              
                            </ul>
                            <div className='continue-button-div'>
                              <div className='required float_right'>
                                * Required Fields
                              </div>
                              <br className="sgl-mb-5"/>
                              <button className='sgl-button float_right' onClick={(this.state.change_div_rider)?this.change_div_rider_selected() : this.change_rider_selected()}>
                                Next
                              </button>
                            </div>
                        </div>
                      {/* add/drp class - Pending requests */}

                        <div id="step_2_container" className='sgl-primary-header class-details, primary-header class-details-header add_entry_options'>
                            <p id="step_2_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Pending Requests</p>
                        </div>
                        <div id='step_2' className='add_entry_class add-entry-div'> 
                            
                            
                            <ul>
                              <li className='entry_people_li'>
                                  { (this.state.pending_requests_list.length > 0) &&
                                    <table className="table table-striped table-hover">
                                      <thead className="classes-header">
                                        <tr className="sgl-primary-header">
                                          <th>Entry Number</th>
                                          <th >Class List</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                      { 
                                        this.state.pending_requests_list.map((data, index) => {
                                          return (
                                            <tr className="" key={data.entry_id}>
                                              <td>{data.number}</td>
                                              {this.getPendingClassesList(data)}
                                            </tr>
                                           )
                                        })
                                      }
                                      </tbody>
                                    </table>
                                  }

                              </li>
                              
                            </ul>
                            {/* <hr/> */}
                            
                        </div>

                    
                    </div>
                </div>
              </div>
              }
              <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
            </div>
        )
    }
  }
  AddDropClass.contextType = SglContext;

  export default AddDropClass;
